import { Component, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Brand } from '../../../model/api/assets/brand';
import { GenericDetail } from '../../generic/generic.detail';

@Component({
    selector: 'brand-detail',
    templateUrl: 'brand.detail.html'
})
export class BrandDetail extends GenericDetail<Brand, number> {

    @ViewChild('detailForm') detailForm: FormGroup;

    setItemDefaultValues() {
        this.item = new Brand();
    }

    public resetForm() {
        this.detailForm.reset();
    }

    public saveItem() {
        super.saveItem();
    }
}